import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as productSolutionAddedIdMain from '../reducers';
import * as productSolutionAddedIdMainSub from '../reducers/add-product-solution.reducer';

export const getProductSolutionAddedIdRequest = createSelector(
  productSolutionAddedIdMain.selectAddProductSolutionState,
  productSolutionAddedIdMainSub.selectAddProductSolutions
);

export const getSavedProductSolutionResponse = createSelector(
  productSolutionAddedIdMain.selectAddProductSolutionState,
  productSolutionAddedIdMainSub.selectSavedProductSolutions
);

export const getSaveSelectedProductSolutionItem = createSelector(
  productSolutionAddedIdMain.selectAddProductSolutionState,
  productSolutionAddedIdMainSub.selectSaveSelectedProductSolutionItem
);
